(function () {
  var grid = document.querySelector('[data-hiw-grid]');
  var nav = document.querySelector('[data-hiw-nav]');
  if (!grid || !nav) return;

  var slides = Array.prototype.slice.call(grid.querySelectorAll('.hiw-product__step'));
  var dots = Array.prototype.slice.call(nav.querySelectorAll('[data-hiw-dot]'));
  var prev = nav.querySelector('[data-hiw-prev]');
  var next = nav.querySelector('[data-hiw-next]');
  if (slides.length === 0) return;

  var cur = 0;

  function update() {
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === cur); });
    if (prev) prev.disabled = cur === 0;
    if (next) next.disabled = cur === slides.length - 1;
  }

  function go(n) {
    cur = Math.max(0, Math.min(slides.length - 1, n));
    var s = slides[cur];
    grid.scrollTo({ left: s.offsetLeft - grid.offsetLeft, behavior: 'smooth' });
    update();
  }

  if (prev) prev.addEventListener('click', function () { go(cur - 1); });
  if (next) next.addEventListener('click', function () { go(cur + 1); });
  dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });

  var st;
  grid.addEventListener('scroll', function () {
    clearTimeout(st);
    st = setTimeout(function () {
      var cx = grid.scrollLeft + grid.offsetWidth / 2;
      var best = 0, bestD = Infinity;
      slides.forEach(function (s, i) {
        var c = s.offsetLeft - grid.offsetLeft + s.offsetWidth / 2;
        var d = Math.abs(c - cx);
        if (d < bestD) { bestD = d; best = i; }
      });
      cur = best;
      update();
    }, 80);
  }, { passive: true });

  update();
})();
